export const tableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
	  {
      label: '名称',
      prop: 'circleName',
      width: 200
    },
    // {
    //   label: '管理员',
    //   prop: 'ownerName',
    //   width: 180,
    //   solt: true
    // },
    {
      label: '帖子',
      prop: 'postCount',
      solt: true,
      sortable: true,
      width: 100
    },
    {
      label: '成员',
      prop: 'memberCount',
      sortable: true,
      width: 100
    },
    {
      label: '圈子类型',
      prop: 'publicText',
      width: 100
    },
    {
      label: '状态',
      prop: 'activeText',
      width: 100
    },
    {
      label: '顺序',
      prop: 'sort',
      width: 100,
      sortable: true
    },
    {
      label: '创建时间',
      prop: 'insertedTime',
      width: 180,
      sortable: true
    }
  ]
}

export const isPublicOptions = [
  {label: '公有', value: 1},
  {label: '私有', value: 0}
]

export const isActiveOptions = [
  {label: '已上架', value: 1},
  {label: '已下架', value: 0}
]

export const circleMemberOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  menu: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
    {
      label: '昵称',
      prop: 'name'
    },
    {
      label: '员工号',
      prop: 'unionId'
    },
    {
      label: '状态',
      prop: 'activeText'
    },
    {
      label: '加入时间',
      prop: 'joinedTime'
    }
  ]
}

export const circleNoticeOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
    // {
    //   label: 'ID',
    //   prop: 'id'
    // },
	  {
      label: '内容',
      prop: 'content'
    },
    {
      label: '发布者',
      prop: 'createdName'
    },
    {
      label: '发布时间',
      prop: 'createdTime'
    },
    {
      label: '状态',
      prop: 'activeText'
    }
  ]
}
